import { memo } from "react";

const ActionBottom = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 7L10 13L4 7"
      stroke="currentColor"
      strokeWidth="1.45124"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(ActionBottom);
